import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facet, FacetFilter } from '@shared/models/search.model';

@Component({
  selector: 'app-recipes-search-facets',
  templateUrl: './recipes-search-facets.component.html',
  styleUrls: ['./recipes-search-facets.component.scss'],
  standalone: false,
})
export class RecipesSearchFacetsComponent {
  @Input()
    searchFacets?: Facet[] | null;
  @Input()
    advancedSearchFacets?: Facet[] | null;
  @Input()
    searchFacetsSemantic?: Facet[] | null;
  @Output()
    filterFacets: EventEmitter<FacetFilter> = new EventEmitter<FacetFilter>();

  emitFacetFilter(facetFilter: FacetFilter): void {
    this.filterFacets.emit(facetFilter);
  }
}
